import EventSrc from "@/assets/images/event/icon.svg";
import polyglot from "@/utils/polyglot";
import BackToSchoolEventSrc from "images/back-to-school/icon.svg";
import moment from "moment";
import Summer from "./events/Summer";
import BackToSchool from "./events/BackToSchool";

const useEvent = () => {
  const events = [
    {
      key: "back_to_school",
      title: polyglot.t("back_to_school.tab_title"),
      startDate: moment("2025-09-01", "YYYY-MM-DD").startOf("day"),
      endDate: moment("2025-09-30", "YYYY-MM-DD").endOf("day"),
      icon: BackToSchoolEventSrc,
      Component: BackToSchool,
    },
    {
      key: "summer",
      title: polyglot.t("summer.tab_title"),
      startDate: moment("2025-06-30", "YYYY-MM-DD").startOf("day"),
      endDate: moment("2025-08-31", "YYYY-MM-DD").endOf("day"),
      icon: EventSrc,
      Component: Summer,
    },
  ].map((event, index, arr) => {
    const isActive = !arr.find((e) => e.isActive)
      ? moment().isBetween(event.startDate, event.endDate)
      : false;
    return {
      ...event,
      isActive,
      id: isActive ? 99 : 99 - (index + 1),
    };
  });
  return { events };
};

export default useEvent;
